export default "__VITE_ASSET__DOCWldfB__"